import { errorMessageFrom } from "../../../../../../../utils/formErrors";
import { ensureOrgDepartments } from "../../../../../../../services/useOrgData";
import React,{useState, useEffect} from 'react';
import {Box,Autocomplete, TextField} from "@mui/material";
import styled from '@emotion/styled';
import Topbar from "../../../../../../../component/TopBar";
import MainBox from "../../../../../container/MainBox";
import BtnPrimary from '../../../../../../../component/PrimaryButton';
import BtnSecondary from '../../../../../../../component/SecondaryButton';
import FormField from '../../../../../../../component/Formfield';
import DateField from '../../../../../../../component/DateField';
import { useLocation } from 'react-router';
import { useNavigate, useParams } from 'react-router';
import SaveDialog from '../../../../../../../component/SaveDialog';
import { updateEmployeeDetailsById } from '../../../../../../../services/employee';
import { getOrgDetails } from '../../../../../../../services/globalData';
import { useNotify } from '../../../../../../../component/NotificationProvider';

import {countryList} from "../../../../../../../component/CountryList";

import { displayFont } from "../../../../../../../theme";
import { tokens } from "../../../../../../../theme";
const TextBox = styled(Box)({
  display: 'block',
  fontSize: '1rem',
  lineHeight: '1.5rem',
  color: tokens.textMuted,
});

const InputStyle = {
  height: '3rem',
  borderRadius: '10px',
  fontSize: '1rem',
  lineHeight: '1.5rem',
  fontWeight:400,
  color: '#2A1D22',
}

const EditDetails = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  const {employeeId}=useParams();
  const {state} = useLocation();
  // This screen edits a specific section and relies on the field data passed via
  // navigation state (from the section's edit button). If reached without it
  // (direct URL / refresh / a stray link), redirect back to the profile rather
  // than crash on the destructure.
  const {data,headingText, name} = state || {};
  const [isDialogOpen,setIsDialogOpen] = useState(false);
  const [formData, setFormData] = useState((data || []).filter(item => item.field !== 'aliasId'));
  const [isDateDialogOpen,setIsDateDialogOpen] = useState(false);
  const [selectedDepartment,setSelectedDepartment] = useState({name:formData[4]?.value||""});
  const [selectedDesignation,setSelectedDesignation] = useState(formData[3]?.value||"");
  const [departments,setDepartments] = useState([]);

  // no section data → nothing to edit here; send them to the profile
  useEffect(() => {
    if (!state) {
      navigate(employeeId ? `/app/employee-details/${employeeId}/profile` : "/app/employees", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=>{
    fetchDepartments();
  },[])

  if (!state) return null;

  const fetchDepartments = async () => {
        try {
          const list = await ensureOrgDepartments();
          const dept = (list || []).map(department => ({
            name: department.name,
            id: department._id
          }));
          setDepartments(dept);
        } catch (error) {
          notify.error(error?.message || "Failed to load departments");
        }
  }

  const onDepartmentChange = (event,selectedValue) =>{
    setSelectedDepartment(selectedValue);
    handleChange("Department",selectedValue?.id);
  }

  const onDesignationChange = (event,selectedValue) =>{
    setSelectedDesignation(selectedValue);
    handleChange("Designation",selectedValue);
  }

  const handleChange = (label, newValue) => {
    setFormData(prevFormData => {
      const updatedFormData = prevFormData.map(item => {
        if (item.label === label) {
          return { ...item, value: newValue }; 
        }
        return item;
      });
      return updatedFormData;
    });
  };

  const transformedObject = formData.reduce((acc, item) => {
    acc[item.field] = item.value;
    return acc;
  }, {});

  const handleSave = async() =>{
    try{
      const res = await updateEmployeeDetailsById(employeeId,transformedObject);
      if(res.success){
        setIsDialogOpen(true);
      } else {
        notify.error(errorMessageFrom(res, "Could not update employee details"));
      }
    }catch(error){
      notify.error(error?.message || "Something went wrong updating the details");
    }
  }

  return (
    <Box sx={{width:"100%"}}>
       <Topbar MainHeading={`${name}'s ${headingText}`} SubHeading="Edit Employee"/>        
       <MainBox sx={{padding: "1.5rem 1.25rem 2rem 1.25rem"}}>
           <Box sx={{fontWeight: 600,fontFamily: displayFont, fontSize:"1.25rem",lineHeight: 1.3}}>
             {headingText}
           </Box>
           <Box sx={{color:tokens.infoText,fontSize:"0.875rem",lineHeight: 1.6,marginBottom: "1.5rem"}}>
             Employee Details 
           </Box>
           <Box sx={{width:"100%", display:"flex", flexWrap:"wrap", justifyContent:"space-between", }}>
               {
                  formData.map((item)=>{
                    return(
                      item.label.includes("Date")?(
                        <DateField
                          label={item.label}
                          value={item.value}
                          past={"enable"}
                          isDialogOpen={isDateDialogOpen}
                          openDialog={() => setIsDateDialogOpen(true)}
                          closeDialog={() => setIsDateDialogOpen(false)}
                          onSelect={(date)=> {
                                    handleChange(item.label, date);
                                    setIsDateDialogOpen(false)
                          }}
                        />
                      ):(
                        item.label.includes("Image")?(
                          <FormField
                              label={item.label}
                              type="file"
                              onChange={(e)=> handleChange(item.label,URL.createObjectURL(e.target.files[0]))}
                          />
                        ):(
                        item.field==="department"?(
                          <Box sx={{width:"48%"}}> 
                              <TextBox>Department</TextBox>
                              <Autocomplete
                                  options={departments}
                                  getOptionLabel={option => option?.name}
                                  size="small"
                                  value={selectedDepartment||null}
                                  onChange={onDepartmentChange}
                                  sx={{
                                    '& .MuiInputBase-root': InputStyle,
                                      "& .MuiOutlinedInput-notchedOutline":{
                                        border: "1px solid #EAD8CC",
                                      }
                                  }}
                                  renderInput={(params) => <TextField {...params}/>}
                              />
                          </Box>
                        ):(
                          item.field==="designation"?(
                            <Box sx={{width:"48%"}}> 
                                <TextBox>Designation</TextBox>
                                <Autocomplete
                                    options={getOrgDetails()?.designations || []}
                                    size="small"
                                    value={selectedDesignation||null}
                                    onChange={onDesignationChange}
                                    sx={{
                                      '& .MuiInputBase-root': InputStyle,
                                        "& .MuiOutlinedInput-notchedOutline":{
                                          border: "1px solid #EAD8CC",
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params}/>}
                                />
                            </Box>
                          ):(item.field==="nationality"?(
                            <Box sx={{width:"48%"}}> 
                                <TextBox>Nationality</TextBox>
                                <Autocomplete
                                    options={countryList}
                                    size="small"
                                    value={item.value||null}
                                    onChange={(event,selectedValue)=> handleChange(item.label,selectedValue)}
                                    sx={{
                                      '& .MuiInputBase-root': InputStyle,
                                        "& .MuiOutlinedInput-notchedOutline":{
                                          border: "1px solid #EAD8CC",
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params}/>}
                                />
                            </Box>
                          ):(
                            <FormField
                              label={item.label}
                              value={item.value}
                              type={item.options?"select":"text"}
                              options={item.options}
                              onChange={(e)=> handleChange(item.label,e.target.value)}
                            />
                        ))
                      )
                    )
                  )
                )
              })
            }
           </Box>
           <Box sx={{display:"flex", gap: "1.25rem", marginBlock: "2rem" }}>
                <BtnPrimary 
                 onClick={handleSave}
                 sx={{ borderRadius: "10px", width: "5.68rem", height: "3.125rem" }}>
                    Save
                </BtnPrimary>
                <BtnSecondary 
                 onClick={() => navigate(-1)}
                 sx={{ borderRadius: "10px", width: "5.68rem", height: "3.125rem" }}>
                    Cancel
                </BtnSecondary>
           </Box>
       </MainBox>
       <SaveDialog open={isDialogOpen} onClose={()=>setIsDialogOpen(false)} redirectLink={`/app/employee-details/${employeeId}`}/>
    </Box>
  ) 
}

export default EditDetails